import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import FilterComponent from './FilterComponent';
import icons from '../../assets/icons';

import '../Filter.css';

class FilterMultiSelect extends FilterComponent {
  static get propTypes() {
    return {
      searchData: PropTypes.array,
      filterKey: PropTypes.string,
      possibleValues: PropTypes.array,
      filterValue: PropTypes.any,
      mapFn: PropTypes.func
    };
  }

  constructor(props) {
    super(props);
    this.state = {
      filterValues: props.filterValues || []
    };
  }

  onFilter() {
    const { onFilter, filterKey } = this.props;
    const { filterValues } = this.state;
    const newFilterValues = filterValues
      ? filterValues.join(',')
      : undefined;

    onFilter(filterKey, newFilterValues);
  }

  onChange(value) {
    const { mapFn } = this.props;
    const { filterValues } = this.state;
    let newFilterValues = filterValues.concat();
    // If filter values already include the value, remove it
    const index = filterValues.findIndex(filterVal => mapFn(filterVal).value === value);
    if (index !== -1) {
      newFilterValues.splice(index, 1);
    } else {
      newFilterValues = newFilterValues.concat(value);
    }
    this.setState({ filterValues: newFilterValues });
  }

  renderCheckbox(option) {
    const { filterValues } = this.state;
    const { label, value } = option;
    const active = filterValues.includes(value);
    const checkboxImg = active ? icons.blue.checkbox_on : icons.blue.checkbox_off;
    return (
      <div className="Filter-checkboxRow" key={value}>
        <input
          type="checkbox"
          className={classnames('Filter-checkbox', { 'is-selected': active })}
          checked={active}
          id={`filter-checkbox-${value}`}
          onChange={() => this.onChange(value)}
        />
        <label className="checkbox-filter-multi-label" htmlFor={`filter-checkbox-${value}`}><img className="checkImg" src={checkboxImg} alt="checkBox" /><span>{label}</span></label>
      </div>
    );
  }

  renderFilterBody() {
    const { filterKey, mapFn, possibleValues } = this.props;
    const options = possibleValues && possibleValues.length > 0
      ? possibleValues.map(mapFn)
      : undefined;

    return (
      <div className={classnames('Filter-body-singleSelect', `filter-body-${filterKey}`)}>
        {options.map(option =>
          this.renderCheckbox(option)
        )}
      </div>
    );
  }
}

export default FilterMultiSelect;



// WEBPACK FOOTER //
// ./src/filter/filterTypes/FilterMultiSelect.js